export const MobileNotAvailableIcon = ({ size = 58, color = 'rgb(24, 20, 54)' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    style={{ color }}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='6' y='2' width='12' height='20' rx='2' stroke='currentColor' strokeWidth='1.8' />
    <line
      x1='9'
      y1='5'
      x2='15'
      y2='5'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
    />
    <circle cx='12' cy='18' r='1' fill='currentColor' />
    <line
      x1='4'
      y1='20'
      x2='20'
      y2='4'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);
